import { IDosage, IPredefinedArticle } from '@alberta/konexi-shared';

export class PredefinedArticleDto implements IPredefinedArticle {
  productGroupId: string;
  articleId: string;
  dosage: IDosage;
  annotation: string;
  hideInShoppingCart: boolean;
}
